import { Event } from '@domain/event';
import { GenericQueryOptions, useGenericQuery } from '@hooks/use-generic-query';
import { UseQueryResult } from '@tanstack/react-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

const getEventByIdFetch = async (eventId?: string) => {
  if (!eventId) return null;
  const url = `${import.meta.env.VITE_EVENTS_HOST}/v1/nightgraph/events/${eventId}`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetEvent = ({
  eventId,
  options,
}: {
  eventId?: string;
  options?: GenericQueryOptions<Event, RequestError>;
}): UseQueryResult<Event, RequestError> => {
  return useGenericQuery<Event, RequestError>(['event-by-id', eventId] as const, () => getEventByIdFetch(eventId), {
    staleTime: 0,
    gcTime: 0,
    enabled: !!eventId,
    ...options,
  });
};
